module.exports = __webpack_public_path__ + "static/img/display_256.fd545bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/display_256.png
// module id = Zcs+
// module chunks = 0